// Bilingual content for the HuntersMapp 2.0 landing page (DE default / EN).
// Store links: fill in once the listings are live.
export const APP_STORE_URL = "https://itunes.apple.com/de/app/huntersmapp/id1236152421";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=de.outlanderlb.huntersmappa";
// URL der Browserversion – sobald eingetragen, erscheinen alle "Browserversion öffnen"-Links automatisch.
export const WEB_APP_URL = "https://web.huntersmapp.com";
export const WEB_APP_ENABLED = /^https?:\/\//.test(WEB_APP_URL);
// Statisches Hosting (Strato): PHP-Endpunkt aus public/api. Alternativ per REACT_APP_CONTACT_ENDPOINT überschreiben.
export const CONTACT_ENDPOINT = process.env.REACT_APP_CONTACT_ENDPOINT || "/api/contact.php";
export const CONTACT_EMAIL = "Info@Outlander-LB.com";
export const CONTACT_PHONE = "08452-7338620";
export const COMPANY = {
  name: "Outlander LB GmbH",
  street: "Birketweg 12",
  city: "85290 Geisenfeld",
  country: "Deutschland",
};

// YouTube tutorials (order = tutorial number). Titles per language live in content.*.tutorials.items.
export const TUTORIAL_VIDEOS = [
  { id: "XZp8AaYBTGE", n: 1 },
  { id: "A-W7aM_Azxs", n: 2 },
  { id: "DoKj0pUqOrk", n: 3 },
  { id: "fnr4JWrWHY0", n: 4 },
  { id: "Ni5UHNUc3Q0", n: 5 },
  { id: "oNSOMXuzVMQ", n: 6 },
];

// Asset-Pfade relativ zum Deployment-Pfad (PUBLIC_URL, z. B. "/neu" für ein Unterverzeichnis)
const asset = (p) => `${process.env.PUBLIC_URL || ""}${p}`;

export const SCREENS = {
  dashboard: asset("/screens/dashboard.webp"),
  revierKarte: asset("/screens/revier-karte.webp"),
  revierAnsitz: asset("/screens/revier-ansitz-windsektor.webp"),
  windampel: asset("/screens/windampel-einstellen.webp"),
  wetter: asset("/screens/revierwetter.webp"),
  buechsenlicht: asset("/screens/buechsenlicht.webp"),
  lockrufe: asset("/screens/lockrufe.webp"),
  aufgaben: asset("/screens/aufgaben.webp"),
  ausruestung: asset("/screens/ausruestung-anlegen.webp"),
  ausruestungLeer: asset("/screens/ausruestung.webp"),
  liveJagd: asset("/screens/live-jagd.webp"),
  skadi: asset("/screens/skadi-chat.webp"),
  tagebuch: asset("/screens/jagdtagebuch.webp"),
  abschuss: asset("/screens/abschussplaene.webp"),
  chat: asset("/screens/revierchat.webp"),
  distanz: asset("/screens/entfernungsmesser.webp"),
  // Praxis-Beispiele
  praxisWindampel: asset("/screens/praxis-windampel.webp"),
  praxisJagdgast: asset("/screens/praxis-einladung.webp"),
  praxisMitglieder: asset("/screens/praxis-mitglieder.webp"),
  praxisWeb: asset("/screens/praxis-web-tagebuch.webp"),
};

export const content = {
  de: {
    meta: {
      title: "HuntersMapp 2.0 – Die Jagd-App für Revier, Live-Jagd & Windampel",
      description:
        "HuntersMapp 2.0: Revierverwaltung, Live-GPS-Tracking, Windampel, Büchsenlicht, Jagdtagebuch, Lockrufe und KI-Assistentin Skadi in einer App für iOS, Android und Browser. 7 Tage kostenlos testen.",
      contactTitle: "Kontakt – HuntersMapp 2.0",
      contactDescription:
        "Fragen zur HuntersMapp 2.0, zum PRO-Abo oder zur VDB-Version? Schreib uns über das Kontaktformular oder direkt per E-Mail an Outlander LB GmbH.",
      legalDescription: "Rechtliche Informationen zur HuntersMapp 2.0 von Outlander LB GmbH.",
    },
    nav: {
      items: [
        { id: "revier", label: "Revier" },
        { id: "live-jagd", label: "Live-Jagd" },
        { id: "werkzeuge", label: "Werkzeuge" },
        { id: "praxis", label: "Praxis" },
        { id: "tutorials", label: "Tutorials" },
        { id: "skadi", label: "Skadi KI" },
        { id: "preise", label: "Preise" },
        { id: "faq", label: "FAQ" },
      ],
      cta: "7 Tage gratis testen",
      webApp: "Web-App",
      langLabel: "Sprache",
    },
    hero: {
      eyebrow: "HuntersMapp 2.0 · iOS · Android · Web",
      titleA: "Das ganze Revier.",
      titleB: "In deiner Hand.",
      subtitle:
        "Revierverwaltung, Live-GPS-Tracking, Windampel und die KI-Assistentin Skadi – vereint in einer App, die im Revier genauso funktioniert wie am Schreibtisch.",
      primaryCta: "Jetzt 7 Tage kostenlos testen",
      secondaryCta: "Funktionen ansehen",
      trust: ["Kostenlos starten", "Jederzeit kündbar", "Made in Germany"],
      screenLabelFront: "Startseite",
      screenLabelBack: "Revierkarte",
      webNote: "Auch am PC:",
      webCta: "Browserversion öffnen",
    },
    ticker: [
      "Revierverwaltung",
      "Live-GPS-Tracking",
      "Windampel",
      "Büchsenlicht",
      "Revierwetter",
      "Jagdtagebuch",
      "Lockrufe",
      "Abschusspläne",
      "Ausrüstungsmanager",
      "Revierchat",
      "Offlinekarten",
      "KML-Import",
      "Skadi KI-Assistentin",
    ],
    revier: {
      index: "01",
      eyebrow: "Revierverwaltung",
      title: "Dein Revier. So genau, wie du es kennst.",
      body:
        "Lege beliebig viele Reviere an – mit Grenzen, Ansitzen, Flächen und Landmarks. Bequem am PC im Browser oder direkt in der App, in Echtzeit synchronisiert. Ob Straßen-, Satelliten- oder Geländekarte: Dein Revier ist immer griffbereit, auch im tiefsten Funkloch.",
      points: [
        {
          title: "Grenzen, Ansitze & Landmarks",
          desc: "Alles digital anlegen, verschieben, kommentieren – auf jeder Kartenansicht.",
        },
        {
          title: "Web & App synchron",
          desc: "Am großen Bildschirm planen, im Revier nutzen. Änderungen sind sofort überall da.",
        },
        {
          title: "Offlinekarten",
          desc: "Kartenausschnitte speichern und ohne Empfang navigieren.",
        },
        {
          title: "KML-Import & -Export",
          desc: "Bestehende Revierdaten aus anderen Tools übernehmen – und dein Revier jederzeit als KML wieder exportieren.",
        },
      ],
      chips: ["Straße", "Satellit", "Gelände", "Offline", "KML Import/Export", "Web & App"],
      screenMain: "Revierkarte mit Ansitzen",
      screenDetail: "Ansitz mit Windsektor",
    },
    live: {
      index: "02",
      eyebrow: "Live-Jagd",
      title: "Jeder Teilnehmer live auf der Karte.",
      body:
        "Bei Gesellschafts- und Drückjagden zeigt HuntersMapp die GPS-Position aller Teilnehmer in Echtzeit – Mitjäger und Jagdgäste eingeschlossen. Koordiniert, übersichtlich und sicher, weil jeder Teilnehmer der Ortung ausdrücklich zustimmt.",
      points: [
        "Live-Positionen aller Teilnehmer auf einer Karte",
        "Ortung nur mit Einwilligung – volle Kontrolle für jeden",
        "Mitjäger & Jagdgäste mit Rollen und Rechten einladen",
        "Einladung per Code über E-Mail, WhatsApp, SMS oder Telegram",
      ],
      screenLabel: "Live-Jagd",
      placeholderNote: "Screenshot folgt",
      stat: { label: "Aktualisierung", value: "Echtzeit" },
    },
    tools: {
      index: "03",
      eyebrow: "Werkzeuge",
      title: "Der komplette Werkzeugkasten. Ein Rucksack weniger.",
      body:
        "Wähle eine Funktion und sieh sie direkt in der App. Alles, was du früher in fünf Apps, einem Notizbuch und einem Wetterdienst hattest.",
      hint: "Funktion auswählen",
      items: [
        {
          id: "windampel",
          icon: "Wind",
          title: "Windampel",
          short: "8-Stunden-Vorschau je Ansitz",
          desc: "Hinterlege für jeden Ansitz die günstige Windrichtung – per Kompass oder von Hand. Die Windampel färbt deine Ansitze in Rot, Gelb und Grün und zeigt dir mit 8-Stunden-Vorschau, wo es sich heute lohnt.",
          screen: "windampel",
        },
        {
          id: "wetter",
          icon: "CloudSun",
          title: "Revierwetter",
          short: "Vorhersage für deinen Standort",
          desc: "Temperatur, Wind und Böen, Regenwahrscheinlichkeit, Bewölkung, Sicht, UV-Index und amtliche Warnungen – punktgenau für dein Revier.",
          screen: "wetter",
        },
        {
          id: "buechsenlicht",
          icon: "MoonStar",
          title: "Büchsenlicht",
          short: "Sonne, Mond & Mondlicht-Index",
          desc: "Beginn und Ende des Büchsenlichts, Sonnen- und Mondzeiten sowie ein Mondlichtindex mit Vorhersage für die nächsten Tage. Ideal zur Planung von Nachtansitzen.",
          screen: "buechsenlicht",
        },
        {
          id: "lockrufe",
          icon: "Volume2",
          title: "Lockrufe",
          short: "Fast 20 Profi-Lockrufe",
          desc: "Hasen- und Kaninchenklage, Enten- und Krähenlocker, Mauspfeifchen, Ranzbeller, Rehblatter und viele mehr – professionell aufgenommen, direkt in der App.",
          screen: "lockrufe",
        },
        {
          id: "tagebuch",
          icon: "BookOpen",
          title: "Jagdtagebuch",
          short: "Anblick, Anschuss, Erlegt, Fallwild",
          desc: "Dokumentiere jedes Ereignis mit Ort, Zeit und Ausrüstung – öffentlich fürs Team oder privat. Mit Filtern auswerten, auf der Karte anzeigen und als CSV exportieren.",
          screen: "tagebuch",
        },
        {
          id: "aufgaben",
          icon: "CheckSquare",
          title: "Revieraufgaben",
          short: "Reparaturen planen & zuweisen",
          desc: "Leiter reparieren, Kirrung auffüllen, Hochsitz kontrollieren: Aufgaben anlegen, terminieren, zuweisen und mit Status Offen, Gestartet und Erledigt nachverfolgen.",
          screen: "aufgaben",
        },
        {
          id: "ausruestung",
          icon: "Crosshair",
          title: "Ausrüstungsmanager",
          short: "Waffen, Munition, Optik",
          desc: "Verwalte Waffen, Munition, Zielfernrohre und Zubehör mit Hersteller, Modell und Kaliber – und verknüpfe sie direkt mit deinen Tagebucheinträgen.",
          screen: "ausruestung",
        },
        {
          id: "abschuss",
          icon: "Target",
          title: "Abschusspläne",
          short: "Planzahlen vs. Ist – tagesaktuell",
          desc: "Tagebucheinträge werden automatisch deinen Planzahlen gegenübergestellt. So siehst du jederzeit, wo du im Jagdjahr stehst.",
          screen: "abschuss",
        },
        {
          id: "chat",
          icon: "MessageCircle",
          title: "Revierchat",
          short: "Team auf dem Laufenden halten",
          desc: "Tagebucheinträge und Aufgaben erscheinen automatisch im Chat. Dazu Texte und Bilder – alles an einem Ort, für alle im Revier.",
          screen: "chat",
        },
        {
          id: "distanz",
          icon: "Ruler",
          title: "Entfernungsmesser",
          short: "Distanzen direkt auf der Karte",
          desc: "Miss präzise Entfernungen zwischen zwei beliebigen Punkten – vom Ansitz zur Kirrung, vom Waldrand zur Wiese.",
          screen: "distanz",
        },
        {
          id: "news",
          icon: "Newspaper",
          title: "Jagd-Nachrichten",
          short: "Verbände, Fachpresse, Aktuelles",
          desc: "Aktuelle Meldungen von Jagd- und Waffenverbänden, Fachzeitschriften und Presse – gebündelt auf deiner Startseite.",
          screen: "dashboard",
        },
      ],
    },
    praxis: {
      index: "04",
      eyebrow: "Aus der Praxis",
      title: "Drei Situationen, die jeder Jäger kennt.",
      body:
        "So sieht HuntersMapp 2.0 im Revieralltag aus – von der Kanzelwahl nach Feierabend bis zur Streckenauswertung am Jahresende.",
      stepsLabel: "So läuft es ab",
      benefitLabel: "Der Nutzen",
      screenNote: "Screenshot folgt",
      cases: [
        {
          id: "windampel",
          kicker: "Arbeiten mit der Windampel",
          title: "Feierabend, 17:30 Uhr – welche Kanzel lohnt sich heute?",
          story:
            "Du hast drei Ansitze im Revier, aber nur zwei Stunden Zeit. Falsch gesessen und womöglich noch die Kanzel wechseln müssen – oder der Wind dreht auf einmal und du sitzt schlecht? Das muss nicht sein: Du öffnest HuntersMapp, und alle deine Ansitze sind schon nach ihrer günstigen Windrichtung hinterlegt. Auf einen Blick siehst du, welche Kanzel für die nächsten acht Stunden grün, gelb oder rot steht – und fährst direkt zur richtigen, statt dem Wild deine Witterung zuzutreiben.",
          steps: [
            "Windrichtung je Ansitz einmalig hinterlegen – per Kompass am Handy oder von Hand eintragen",
            "HuntersMapp gleicht das laufend mit der aktuellen Wettervorhersage ab",
            "Jeder Ansitz wird automatisch grün, gelb oder rot eingefärbt",
            "8-Stunden-Vorschau zeigt dir, ob sich der Wind bis zum Ansitz noch dreht",
          ],
          benefit:
            "Keine Enttäuschungsansitze mehr, weil der Wind falsch stand – die Entscheidung „welche Kanzel heute“ dauert 10 Sekunden statt Kopfrechnen oder Bauchgefühl.",
          device: "phone",
          screenLabel: "Windampel im Revier",
          screen: "praxisWindampel",
        },
        {
          id: "jagdgast",
          kicker: "Einladung Jagdgast",
          title: "Samstagnachmittag – ein Jagdgast kommt zum gemeinsamen Ansitz",
          story:
            "Du lädst einen Bekannten zu einem Ansitz in deinem Revier ein. Statt langer WhatsApp-Nachrichten mit Wegbeschreibung schickst du ihm einen Einladungscode. Er sieht seinen Treffpunkt direkt auf der Karte, weiß, wo er hindarf – und was er anblickt oder erlegt, landet automatisch im gemeinsamen Tagebuch. Du als Pächter musst am Ende nichts mühsam zusammensammeln, sondern siehst sofort, wer wann wo was gesehen hat.",
          steps: [
            "Jagdgast per Code einladen – per E-Mail, WhatsApp, SMS oder Telegram",
            "Treffpunkt auf der Karte festlegen und mit dem Gast teilen",
            "Rolle vergeben: Jagdgast mit passenden Rechten",
            "Gast trägt seinen Anblick oder Anschuss direkt in der App ein",
            "Du als Revierverantwortlicher siehst im Nachgang, an welcher Kanzel und wann etwas beobachtet wurde",
          ],
          benefit:
            "Keine Zettelwirtschaft, kein „was hast du nochmal gesehen“ am Telefon – die ganze Organisation und Dokumentation läuft nebenbei mit, während der Gast einfach jagt.",
          device: "phone",
          screenLabel: "Einladung per Code",
          screen: "praxisJagdgast",
          screen2: "praxisMitglieder",
          screenLabel2: "Rollen & Mitglieder",
        },
        {
          id: "strecke",
          kicker: "Auswertung der Jagdstrecke",
          title: "Ende des Jagdjahres – wo stehen wir eigentlich?",
          story:
            "Statt Excel-Tabellen und handschriftlichen Strecklisten öffnest du am Laptop die Web-Version von HuntersMapp. Alle Tagebucheinträge des Jahres – vom eigenen Ansitz bis zu den Einträgen deiner Jagdgäste – sind schon automatisch erfasst. Du filterst nach Wildart, Zeitraum oder Revierteil, siehst auf der Karte, wo die Strecke gefallen ist, und gleichst sie direkt mit deinem Abschussplan ab. Für die Meldung an Behörde oder Verband exportierst du die Liste als CSV – fertig.",
          steps: [
            "Jagdtagebuch nach Wildart, Zeitraum oder Ansitz filtern",
            "Strecke auf der Karte anzeigen – wer hat wo was erlegt",
            "Ist-Zahlen automatisch mit dem hinterlegten Abschussplan vergleichen",
            "Ergebnis als CSV exportieren, z. B. für Verband, Behörde oder eigene Auswertung",
          ],
          benefit:
            "Der Jahresüberblick, für den man früher einen Abend am Küchentisch mit Zettel und Taschenrechner gebraucht hat, ist in ein paar Klicks erledigt – am besten am großen Bildschirm, wo man Karte und Tabelle gleichzeitig im Blick hat.",
          device: "browser",
          screenLabel: "Jagdtagebuch in der Web-Version – Export als Streckenmeldung.csv",
          screen: "praxisWeb",
          webCta: "Browserversion öffnen",
        },
      ],
    },
    tutorials: {
      index: "05",
      eyebrow: "Schritt für Schritt",
      title: "HuntersMapp 2.0 Tutorials",
      body:
        "Sechs kurze Videos zeigen dir die wichtigsten Funktionen direkt in der App – vom ersten Revier bis zum Büchsenlicht. Zum Ansehen einfach aufklappen.",
      label: "Tutorial",
      play: "Video abspielen",
      privacy: "Beim Abspielen wird eine Verbindung zu YouTube hergestellt.",
      openOnYoutube: "Auf YouTube ansehen",
      items: [
        { title: "Reviere anlegen & verwalten", desc: "Revier erstellen, Grenzen ziehen, Ansitze und Landmarks setzen." },
        { title: "Jagdtagebuch führen", desc: "Anblick, Anschuss, Erlegt und Fallwild erfassen und auswerten." },
        { title: "Abschussplan anlegen", desc: "Planzahlen hinterlegen und automatisch mit dem Tagebuch abgleichen." },
        { title: "Aufgabenliste & Aufgaben verteilen", desc: "Revierarbeiten anlegen, terminieren und dem Team zuweisen." },
        { title: "Revierchat & Aktivitäten", desc: "Mit dem Revierteam kommunizieren und Aktivitäten im Blick behalten." },
        { title: "Wetter & Büchsenlicht", desc: "Revierwetter lesen und Büchsenlicht sowie Mondphasen für den Ansitz nutzen." },
      ],
    },
    skadi: {
      index: "06",
      eyebrow: "KI-Jagdassistentin",
      title: "Frag Skadi.",
      subtitle:
        "Die integrierte KI-Assistentin beantwortet jagdliche Fragen und hilft bei der Bedienung der App – schnell, zuverlässig und rund um die Uhr.",
      examples: [
        "Wann beginnt die Jagdzeit auf Rehböcke in Bayern?",
        "Wie lege ich eine Windampel für meinen Ansitz an?",
        "Welche Munition eignet sich für Schwarzwild auf 150 m?",
      ],
      points: [
        { title: "Jagdliches Wissen", desc: "Antworten auf Fragen rund um Wild, Jagdzeiten und Praxis." },
        { title: "App-Hilfe", desc: "Skadi erklärt Funktionen und führt dich Schritt für Schritt." },
        { title: "Faires Token-Modell", desc: "Guthaben für 5 €, 20 € oder 50 € – kein Abo." },
      ],
      note: "Derzeit für Deutschland verfügbar. Als KI-System kann Skadi Fehler machen – die Antworten ersetzen keine Rechtsberatung.",
      screenLabel: "Skadi Chat",
      placeholderNote: "Screenshot folgt",
    },
    pricing: {
      index: "07",
      eyebrow: "Preise & Versionen",
      title: "Kostenlos starten. Wachsen, wenn es passt.",
      subtitle:
        "Die Gratisversion bleibt gratis. PRO testest du 7 Tage kostenlos – danach 5,99 € im Monat oder 49,99 € im Jahr, jederzeit kündbar über die Abo-Verwaltung von App Store oder Google Play.",
      perMonth: "pro Monat",
      perYear: "pro Jahr",
      yearlySave: "spare rund 30 %",
      mostPopular: "Beliebteste Wahl",
      tiers: [
        {
          id: "gratis",
          name: "Gratis",
          price: "0 €",
          priceNote: "für immer",
          tagline: "Der Einstieg in dein digitales Revier",
          cta: "Kostenlos loslegen",
          highlighted: false,
          features: [
            "Jagd-Nachrichten & News",
            "Basis-Revierverwaltung (1 Revier)",
            "Von PRO-Nutzern einladbar",
            "Jagdtagebuch (eingeschränkt)",
            "Revierchat (nur Logbuch)",
          ],
        },
        {
          id: "pro",
          name: "PRO",
          price: "5,99 €",
          priceNote: "pro Monat",
          altPrice: "49,99 €",
          altPriceNote: "pro Jahr · spare rund 30 %",
          trial: "7 Tage kostenlos testen",
          cancel: "Jederzeit kündbar über die Abo-Verwaltung von App Store / Google Play",
          tagline: "Alle Funktionen. Kein Kompromiss.",
          cta: "Jetzt 7 Tage kostenlos testen",
          highlighted: true,
          features: [
            "Alles aus Gratis",
            "Unbegrenzte Reviere & Live-Jagd GPS",
            "Komplettes Jagdtagebuch & Abschusspläne",
            "Windampel, Revierwetter & Büchsenlicht",
            "Lockrufe & Ausrüstungsmanager",
            "Offlinekarten, KML-Import & -Export",
            "Skadi KI-Assistentin (Token-basiert)",
          ],
        },
        {
          id: "vdb",
          name: "VDB",
          price: "Kostenlos",
          priceNote: "für VDB-Fördermitglieder",
          tagline: "Exklusiv für den Verband",
          note: "Melden Sie sich in der HuntersMapp 2.0 mit Ihrer VDB-E-Mail und Ihrem VDB-Passwort an und die VDB-Version der HuntersMapp wird automatisch für Sie freigeschaltet.",
          cta: "VDB-Zugang aktivieren",
          highlighted: false,
          features: [
            "Alle PRO-Funktionen inklusive",
            "Exklusiver VDB-Sonderbereich",
            "Persönliches Fördermitgliedskonto",
            "VDB-spezifische Funktionen",
          ],
        },
      ],
    },
    faq: {
      index: "08",
      eyebrow: "Fragen & Antworten",
      title: "Gut zu wissen.",
      items: [
        {
          q: "Auf welchen Geräten läuft HuntersMapp?",
          a: "Auf iPhone und Android-Smartphones. Reviere, Grenzen und Landmarks kannst du außerdem bequem im Browser am PC anlegen – alles wird in Echtzeit mit der App synchronisiert.",
        },
        {
          q: "Funktioniert die App auch ohne Empfang?",
          a: "Ja. Mit Offlinekarten (PRO) speicherst du Kartenausschnitte deines Reviers vorab und navigierst auch im tiefsten Funkloch.",
        },
        {
          q: "Wie sicher ist das Live-GPS-Tracking?",
          a: "Die Position wird nur geteilt, wenn ein Teilnehmer ausdrücklich zustimmt. Über Rollen legst du fest, wer was sehen und bearbeiten darf.",
        },
        {
          q: "Kann ich mein bestehendes Revier übernehmen?",
          a: "Ja. Per KML-Import übernimmst du Reviergrenzen und Punkte aus anderen Programmen in wenigen Sekunden. Umgekehrt exportierst du dein Revier jederzeit als KML-Datei.",
        },
        {
          q: "Was kostet Skadi?",
          a: "Skadi läuft über ein Token-Guthaben (5 €, 20 € oder 50 €) – kein Abo. Als KI-System kann Skadi Fehler machen; die Antworten ersetzen keine Rechtsberatung. Derzeit für Deutschland verfügbar.",
        },
        {
          q: "Was ist die VDB-Version?",
          a: "Fördermitglieder des VDB erhalten alle PRO-Funktionen kostenlos, dazu einen exklusiven VDB-Sonderbereich mit verbandsspezifischen Funktionen. Melden Sie sich in der HuntersMapp 2.0 mit Ihrer VDB-E-Mail und Ihrem VDB-Passwort an und die VDB-Version der HuntersMapp wird automatisch für Sie freigeschaltet.",
        },
        {
          q: "Was kostet PRO und wie kündige ich?",
          a: "PRO testest du 7 Tage kostenlos. Danach kostet es 5,99 € im Monat oder 49,99 € im Jahr. Gekündigt wird jederzeit über die Abo-Verwaltung von App Store oder Google Play.",
        },
        {
          q: "Gibt es HuntersMapp auch für den Browser?",
          a: "Ja. Die Web-Version läuft im Browser am PC oder Laptop – ideal, um Reviere anzulegen, das Jagdtagebuch auszuwerten oder Abschusspläne zu pflegen. Alles wird in Echtzeit mit der App synchronisiert.",
          link: { label: "Browserversion öffnen", href: "web" },
        },
      ],
    },
    finalCta: {
      eyebrow: "Bereit fürs Revier?",
      title: "Hol dir HuntersMapp 2.0.",
      subtitle:
        "Alle PRO-Funktionen 7 Tage kostenlos testen. Jederzeit kündbar über die Abo-Verwaltung von App Store oder Google Play.",
      primaryCta: "Jetzt 7 Tage kostenlos testen",
    },
    footer: {
      tagline:
        "Die Jagd-App für Revierverwaltung, Live-GPS-Tracking, Windampel und KI-Assistenz.",
      columns: [
        {
          title: "Produkt",
          links: [
            { label: "Revierverwaltung", href: "/#revier" },
            { label: "Live-Jagd", href: "/#live-jagd" },
            { label: "Werkzeuge", href: "/#werkzeuge" },
            { label: "Aus der Praxis", href: "/#praxis" },
            { label: "Tutorials", href: "/#tutorials" },
            { label: "Web-App (Browser)", href: WEB_APP_URL },
            { label: "Skadi KI", href: "/#skadi" },
            { label: "Preise", href: "/#preise" },
          ],
        },
        {
          title: "Rechtliches",
          links: [
            { label: "Kontakt", href: "/kontakt" },
            { label: "Impressum", href: "/impressum" },
            { label: "Datenschutzerklärung", href: "/datenschutz" },
            { label: "Nutzungsbedingungen", href: "/nutzungsbedingungen" },
            { label: "AGB", href: "/agb" },
          ],
        },
      ],
      download: "App laden",
      rights: "Alle Rechte vorbehalten.",
      credit: "Designed by",
    },
    legal: {
      back: "Zurück zur Startseite",
      eyebrow: "Rechtliches",
      langNote: null,
      updated: "Stand",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Sprich mit uns.",
      subtitle:
        "Fragen zur App, zum PRO-Abo oder zur VDB-Version? Presse- oder Partneranfrage? Schreib uns – wir melden uns in der Regel innerhalb von zwei Werktagen.",
      directTitle: "Direkt erreichen",
      form: {
        name: "Name",
        namePh: "Vor- und Nachname",
        email: "E-Mail",
        emailPh: "du@beispiel.de",
        topic: "Thema",
        topics: [
          { value: "allgemein", label: "Allgemeine Frage" },
          { value: "support", label: "Support / technisches Problem" },
          { value: "pro", label: "PRO-Abo & Abrechnung" },
          { value: "vdb", label: "VDB-Version" },
          { value: "revier", label: "Revierverwaltung & Import" },
          { value: "presse", label: "Presse & Partner" },
        ],
        message: "Nachricht",
        messagePh: "Worum geht es?",
        consent: "Ich habe die",
        consentLink: "Datenschutzerklärung",
        consentTail: "gelesen und bin mit der Verarbeitung meiner Angaben zur Bearbeitung der Anfrage einverstanden.",
        submit: "Nachricht senden",
        sending: "Wird gesendet …",
        successTitle: "Danke, deine Nachricht ist angekommen.",
        successBody: "Wir melden uns so schnell wie möglich bei dir.",
        again: "Weitere Nachricht schreiben",
        errorTitle: "Das hat leider nicht geklappt.",
        errorBody: "Bitte versuch es gleich noch einmal oder schreib uns direkt per E-Mail.",
        required: "Pflichtfeld",
        invalidEmail: "Bitte eine gültige E-Mail-Adresse angeben.",
        tooShort: "Bitte etwas ausführlicher (mindestens 10 Zeichen).",
        consentRequired: "Bitte der Verarbeitung zustimmen.",
      },
    },
    appstore: {
      ios: { top: "Laden im", bottom: "App Store" },
      android: { top: "Jetzt bei", bottom: "Google Play" },
    },
    consent: {
      title: "Cookies & externe Dienste",
      body:
        "Wir verwenden nur technisch notwendige Speicherung (Spracheinstellung und deine Auswahl hier). Externe Inhalte wie YouTube-Videos laden wir erst, wenn du zustimmst – dabei werden Daten an Google übertragen.",
      acceptAll: "Alle akzeptieren",
      rejectAll: "Nur notwendige",
      settings: "Einstellungen",
      save: "Auswahl speichern",
      back: "Zurück",
      manage: "Cookie-Einstellungen",
      privacy: "Datenschutzerklärung",
      imprint: "Impressum",
      alwaysOn: "Immer aktiv",
      categories: [
        {
          id: "necessary",
          name: "Notwendig",
          desc: "Speichert deine Sprachwahl und diese Einwilligung im Browser (localStorage). Keine Weitergabe an Dritte.",
          required: true,
        },
        {
          id: "media",
          name: "Externe Medien",
          desc: "YouTube-Videos (Google Ireland Ltd.). Beim Laden werden IP-Adresse und Geräteinformationen an Google übertragen, YouTube kann Cookies setzen.",
          required: false,
        },
      ],
      blocked: {
        title: "YouTube-Video blockiert",
        body: "Du hast externe Medien nicht zugelassen. Beim Laden werden Daten an Google übertragen.",
        once: "Nur dieses Video laden",
        allow: "Externe Medien immer erlauben",
      },
    },
    placeholder: {
      label: "Platzhalter",
      note: "Screenshot folgt",
    },
  },

  en: {
    meta: {
      title: "HuntersMapp 2.0 – The Hunting App for Territory, Live Hunt & Wind Indicator",
      description:
        "HuntersMapp 2.0: territory management, live GPS tracking, wind indicator, shooting light, hunting diary, game calls and the AI assistant Skadi in one app for iOS, Android and browser. 7-day free trial.",
      contactTitle: "Contact – HuntersMapp 2.0",
      contactDescription:
        "Questions about HuntersMapp 2.0, the PRO subscription or the VDB version? Write to us via the contact form or directly by email to Outlander LB GmbH.",
      legalDescription: "Legal information about HuntersMapp 2.0 by Outlander LB GmbH.",
    },
    nav: {
      items: [
        { id: "revier", label: "Territory" },
        { id: "live-jagd", label: "Live Hunt" },
        { id: "werkzeuge", label: "Tools" },
        { id: "praxis", label: "Use cases" },
        { id: "tutorials", label: "Tutorials" },
        { id: "skadi", label: "Skadi AI" },
        { id: "preise", label: "Pricing" },
        { id: "faq", label: "FAQ" },
      ],
      cta: "Start 7-day trial",
      webApp: "Web app",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "HuntersMapp 2.0 · iOS · Android · Web",
      titleA: "Your whole territory.",
      titleB: "In your hand.",
      subtitle:
        "Territory management, live GPS tracking, wind indicator and the AI assistant Skadi – combined in one app that works as well in the field as it does at your desk.",
      primaryCta: "Start your 7-day free trial",
      secondaryCta: "See the features",
      trust: ["Start for free", "Cancel anytime", "Made in Germany"],
      screenLabelFront: "Home",
      screenLabelBack: "Territory map",
      webNote: "Also on your PC:",
      webCta: "Open the browser version",
    },
    ticker: [
      "Territory management",
      "Live GPS tracking",
      "Wind indicator",
      "Shooting light",
      "Territory weather",
      "Hunting diary",
      "Game calls",
      "Cull plans",
      "Equipment manager",
      "Territory chat",
      "Offline maps",
      "KML import",
      "Skadi AI assistant",
    ],
    revier: {
      index: "01",
      eyebrow: "Territory management",
      title: "Your territory. As precise as you know it.",
      body:
        "Create any number of territories – with boundaries, stands, areas and landmarks. Comfortably in the browser on your PC or directly in the app, synced in real time. Street, satellite or terrain map: your territory is always at hand, even in the deepest dead zone.",
      points: [
        {
          title: "Boundaries, stands & landmarks",
          desc: "Create, move and annotate everything digitally – on every map view.",
        },
        {
          title: "Web & app in sync",
          desc: "Plan on the big screen, use it in the field. Changes show up everywhere instantly.",
        },
        {
          title: "Offline maps",
          desc: "Save map sections and navigate without any signal.",
        },
        {
          title: "KML import & export",
          desc: "Bring existing territory data over from other tools – and export your territory as KML at any time.",
        },
      ],
      chips: ["Street", "Satellite", "Terrain", "Offline", "KML import/export", "Web & app"],
      screenMain: "Territory map with stands",
      screenDetail: "Stand with wind sector",
    },
    live: {
      index: "02",
      eyebrow: "Live hunt",
      title: "Every participant, live on the map.",
      body:
        "During driven and group hunts, HuntersMapp shows the real-time GPS position of every participant – fellow hunters and guests included. Coordinated, clear and safe, because every participant explicitly consents to being located.",
      points: [
        "Live positions of all participants on one map",
        "Location sharing only with consent – full control for everyone",
        "Invite fellow hunters & guests with roles and permissions",
        "Invite by code via email, WhatsApp, SMS or Telegram",
      ],
      screenLabel: "Live hunt",
      placeholderNote: "Screenshot coming soon",
      stat: { label: "Updates", value: "Real-time" },
    },
    tools: {
      index: "03",
      eyebrow: "Tools",
      title: "The complete toolkit. One less backpack.",
      body:
        "Pick a feature and see it right in the app. Everything you used to spread across five apps, a notebook and a weather service.",
      hint: "Select a feature",
      items: [
        {
          id: "windampel",
          icon: "Wind",
          title: "Wind indicator",
          short: "8-hour forecast per stand",
          desc: "Store the favourable wind direction for every stand – via compass or by hand. The wind indicator colours your stands red, yellow and green and shows you with an 8-hour forecast where it pays off today.",
          screen: "windampel",
        },
        {
          id: "wetter",
          icon: "CloudSun",
          title: "Territory weather",
          short: "Forecast for your exact spot",
          desc: "Temperature, wind and gusts, rain probability, cloud cover, visibility, UV index and official warnings – pinpointed to your territory.",
          screen: "wetter",
        },
        {
          id: "buechsenlicht",
          icon: "MoonStar",
          title: "Shooting light",
          short: "Sun, moon & moonlight index",
          desc: "Start and end of legal shooting light, sun and moon times plus a moonlight index with a forecast for the coming days. Ideal for planning night sits.",
          screen: "buechsenlicht",
        },
        {
          id: "lockrufe",
          icon: "Volume2",
          title: "Game calls",
          short: "Nearly 20 professional calls",
          desc: "Hare and rabbit distress, duck and crow calls, mouse squeak, fox bark, roe bleat and many more – professionally recorded, right in the app.",
          screen: "lockrufe",
        },
        {
          id: "tagebuch",
          icon: "BookOpen",
          title: "Hunting diary",
          short: "Sightings, shots, harvests, fallen game",
          desc: "Log every event with location, time and equipment – public for the team or private. Analyse with filters, show on the map and export as CSV.",
          screen: "tagebuch",
        },
        {
          id: "aufgaben",
          icon: "CheckSquare",
          title: "Territory tasks",
          short: "Plan & assign maintenance",
          desc: "Fix the ladder, refill the bait site, check the high seat: create, schedule and assign tasks and track them with Open, Started and Done.",
          screen: "aufgaben",
        },
        {
          id: "ausruestung",
          icon: "Crosshair",
          title: "Equipment manager",
          short: "Firearms, ammo, optics",
          desc: "Manage firearms, ammunition, scopes and accessories with manufacturer, model and calibre – and link them directly to your diary entries.",
          screen: "ausruestung",
        },
        {
          id: "abschuss",
          icon: "Target",
          title: "Cull plans",
          short: "Plan vs. actual – always current",
          desc: "Diary entries are automatically compared against your planned numbers, so you always know where you stand in the hunting year.",
          screen: "abschuss",
        },
        {
          id: "chat",
          icon: "MessageCircle",
          title: "Territory chat",
          short: "Keep the team in the loop",
          desc: "Diary entries and tasks appear automatically in the chat. Plus text and images – all in one place, for everyone in the territory.",
          screen: "chat",
        },
        {
          id: "distanz",
          icon: "Ruler",
          title: "Distance meter",
          short: "Distances right on the map",
          desc: "Measure precise distances between any two points – from the stand to the bait site, from the forest edge to the meadow.",
          screen: "distanz",
        },
        {
          id: "news",
          icon: "Newspaper",
          title: "Hunting news",
          short: "Associations, press, updates",
          desc: "Latest news from hunting and firearms associations, magazines and the press – bundled on your home screen.",
          screen: "dashboard",
        },
      ],
    },
    praxis: {
      index: "04",
      eyebrow: "In practice",
      title: "Three situations every hunter knows.",
      body:
        "This is what HuntersMapp 2.0 looks like in everyday hunting – from choosing a stand after work to the bag analysis at the end of the season.",
      stepsLabel: "How it works",
      benefitLabel: "The benefit",
      screenNote: "Screenshot coming soon",
      cases: [
        {
          id: "windampel",
          kicker: "Working with the wind indicator",
          title: "After work, 5:30 pm – which stand is worth it today?",
          story:
            "You have three stands in your territory but only two hours. Sat at the wrong stand and maybe had to move – or the wind suddenly turns and you are sitting badly? It does not have to be that way: you open HuntersMapp, and every stand already has its favourable wind direction stored. At a glance you see which stand is green, yellow or red for the next eight hours – and drive straight to the right one instead of pushing your scent towards the game.",
          steps: [
            "Store the wind direction once per stand – via the phone compass or by hand",
            "HuntersMapp continuously matches it against the current weather forecast",
            "Every stand is automatically coloured green, yellow or red",
            "The 8-hour forecast shows whether the wind will still turn before your sit",
          ],
          benefit:
            "No more disappointing sits because the wind was wrong – the decision “which stand today” takes 10 seconds instead of mental arithmetic or gut feeling.",
          device: "phone",
          screenLabel: "Wind indicator in the territory",
          screen: "praxisWindampel",
        },
        {
          id: "jagdgast",
          kicker: "Inviting a hunting guest",
          title: "Saturday afternoon – a guest joins you for a sit",
          story:
            "You invite an acquaintance to a sit in your territory. Instead of long WhatsApp messages with directions, you send an invitation code. They see their meeting point directly on the map, know where they may go – and whatever they sight or harvest lands automatically in the shared diary. As the lessee you do not have to collect anything afterwards; you see immediately who saw what, where and when.",
          steps: [
            "Invite the guest by code – via email, WhatsApp, SMS or Telegram",
            "Set the meeting point on the map and share it with the guest",
            "Assign a role: hunting guest with the appropriate permissions",
            "The guest logs sightings or shots directly in the app",
            "As the person in charge you see afterwards at which stand and when something was observed",
          ],
          benefit:
            "No paperwork, no “what did you see again” on the phone – the whole organisation and documentation runs alongside while the guest simply hunts.",
          device: "phone",
          screenLabel: "Invitation by code",
          screen: "praxisJagdgast",
          screen2: "praxisMitglieder",
          screenLabel2: "Roles & members",
        },
        {
          id: "strecke",
          kicker: "Analysing the bag",
          title: "End of the hunting year – where do we actually stand?",
          story:
            "Instead of Excel sheets and handwritten bag lists, you open the web version of HuntersMapp on your laptop. All diary entries of the year – from your own sits to those of your guests – are already captured automatically. You filter by species, period or part of the territory, see on the map where game was taken and compare it directly with your cull plan. For the report to the authority or association you export the list as CSV – done.",
          steps: [
            "Filter the hunting diary by species, period or stand",
            "Show the bag on the map – who harvested what, where",
            "Compare actual numbers automatically with the stored cull plan",
            "Export the result as CSV, e.g. for the association, authority or your own analysis",
          ],
          benefit:
            "The annual overview that used to take an evening at the kitchen table with paper and calculator is done in a few clicks – ideally on the big screen with map and table side by side.",
          device: "browser",
          screenLabel: "Hunting diary in the web version – export as CSV",
          screen: "praxisWeb",
          webCta: "Open the browser version",
        },
      ],
    },
    tutorials: {
      index: "05",
      eyebrow: "Step by step",
      title: "HuntersMapp 2.0 Tutorials",
      body:
        "Six short videos walk you through the key features right inside the app – from your first territory to shooting light. Expand an item to watch. Videos are in German.",
      label: "Tutorial",
      play: "Play video",
      privacy: "Playing the video connects to YouTube.",
      openOnYoutube: "Watch on YouTube",
      items: [
        { title: "Create & manage territories", desc: "Set up a territory, draw boundaries, place stands and landmarks." },
        { title: "Keep the hunting diary", desc: "Log sightings, shots, harvests and fallen game, then analyse them." },
        { title: "Set up a cull plan", desc: "Enter planned numbers and compare them automatically with the diary." },
        { title: "Task list & assigning tasks", desc: "Create territory jobs, schedule them and assign them to the team." },
        { title: "Territory chat & activities", desc: "Communicate with your team and keep track of activities." },
        { title: "Weather & shooting light", desc: "Read territory weather and use shooting light and moon phases for your sit." },
      ],
    },
    skadi: {
      index: "06",
      eyebrow: "AI hunting assistant",
      title: "Ask Skadi.",
      subtitle:
        "The built-in AI assistant answers hunting questions and helps you use the app – fast, reliable and around the clock.",
      examples: [
        "When does the roebuck season open in Bavaria?",
        "How do I set up a wind indicator for my stand?",
        "Which ammunition suits wild boar at 150 m?",
      ],
      points: [
        { title: "Hunting knowledge", desc: "Answers on game, seasons and field practice." },
        { title: "In-app help", desc: "Skadi explains features and guides you step by step." },
        { title: "Fair token model", desc: "Credit for €5, €20 or €50 – no subscription." },
      ],
      note: "Currently available for Germany. As an AI system, Skadi can make mistakes – its answers are no substitute for legal advice.",
      screenLabel: "Skadi chat",
      placeholderNote: "Screenshot coming soon",
    },
    pricing: {
      index: "07",
      eyebrow: "Pricing & versions",
      title: "Start free. Grow when it fits.",
      subtitle:
        "The free version stays free. Try PRO free for 7 days – then €5.99 per month or €49.99 per year, cancel anytime via the subscription settings of the App Store or Google Play.",
      perMonth: "per month",
      perYear: "per year",
      yearlySave: "save around 30%",
      mostPopular: "Most popular",
      tiers: [
        {
          id: "gratis",
          name: "Free",
          price: "€0",
          priceNote: "forever",
          tagline: "Your entry into the digital territory",
          cta: "Get started free",
          highlighted: false,
          features: [
            "Hunting news & updates",
            "Basic territory management (1 territory)",
            "Can be invited by PRO users",
            "Hunting diary (limited)",
            "Territory chat (logbook only)",
          ],
        },
        {
          id: "pro",
          name: "PRO",
          price: "€5.99",
          priceNote: "per month",
          altPrice: "€49.99",
          altPriceNote: "per year · save around 30%",
          trial: "7-day free trial",
          cancel: "Cancel anytime via the App Store / Google Play subscription settings",
          tagline: "All features. No compromise.",
          cta: "Start your 7-day free trial",
          highlighted: true,
          features: [
            "Everything in Free",
            "Unlimited territories & live hunt GPS",
            "Complete hunting diary & cull plans",
            "Wind indicator, weather & shooting light",
            "Game calls & equipment manager",
            "Offline maps, KML import & export",
            "Skadi AI assistant (token-based)",
          ],
        },
        {
          id: "vdb",
          name: "VDB",
          price: "Free",
          priceNote: "for VDB supporting members",
          tagline: "Exclusive to the association",
          note: "Sign in to HuntersMapp 2.0 with your VDB email and VDB password – the VDB version is unlocked for you automatically.",
          cta: "Activate VDB access",
          highlighted: false,
          features: [
            "All PRO features included",
            "Exclusive VDB member area",
            "Personal supporting-member account",
            "VDB-specific functions",
          ],
        },
      ],
    },
    faq: {
      index: "08",
      eyebrow: "Questions & answers",
      title: "Good to know.",
      items: [
        {
          q: "Which devices does HuntersMapp run on?",
          a: "On iPhone and Android smartphones. You can also create territories, boundaries and landmarks in the browser on your PC – everything syncs with the app in real time.",
        },
        {
          q: "Does the app work without signal?",
          a: "Yes. With offline maps (PRO) you save map sections of your territory in advance and navigate even in the deepest dead zone.",
        },
        {
          q: "How safe is live GPS tracking?",
          a: "A position is only shared when a participant explicitly consents. Roles define who can see and edit what.",
        },
        {
          q: "Can I bring over my existing territory?",
          a: "Yes. Via KML import you transfer territory boundaries and points from other programs in seconds. And you can export your territory as a KML file at any time.",
        },
        {
          q: "What does Skadi cost?",
          a: "Skadi runs on a token credit (€5, €20 or €50) – no subscription. As an AI system, Skadi can make mistakes; its answers are no substitute for legal advice. Currently available for Germany.",
        },
        {
          q: "What is the VDB version?",
          a: "Supporting members of the VDB get all PRO features for free, plus an exclusive VDB area with association-specific functions. Sign in to HuntersMapp 2.0 with your VDB email and VDB password – the VDB version is unlocked for you automatically.",
        },
        {
          q: "What does PRO cost and how do I cancel?",
          a: "You try PRO free for 7 days. After that it costs €5.99 per month or €49.99 per year. Cancel anytime via the subscription settings of the App Store or Google Play.",
        },
        {
          q: "Is HuntersMapp available in the browser?",
          a: "Yes. The web version runs in the browser on your PC or laptop – ideal for setting up territories, analysing the hunting diary or maintaining cull plans. Everything syncs with the app in real time.",
          link: { label: "Open the browser version", href: "web" },
        },
      ],
    },
    finalCta: {
      eyebrow: "Ready for the field?",
      title: "Get HuntersMapp 2.0.",
      subtitle: "Try all PRO features free for 7 days. Cancel anytime via the App Store or Google Play subscription settings.",
      primaryCta: "Start your 7-day free trial",
    },
    footer: {
      tagline:
        "The hunting app for territory management, live GPS tracking, wind indicator and AI assistance.",
      columns: [
        {
          title: "Product",
          links: [
            { label: "Territory management", href: "/#revier" },
            { label: "Live hunt", href: "/#live-jagd" },
            { label: "Tools", href: "/#werkzeuge" },
            { label: "Use cases", href: "/#praxis" },
            { label: "Tutorials", href: "/#tutorials" },
            { label: "Web app (browser)", href: WEB_APP_URL },
            { label: "Skadi AI", href: "/#skadi" },
            { label: "Pricing", href: "/#preise" },
          ],
        },
        {
          title: "Legal",
          links: [
            { label: "Contact", href: "/kontakt" },
            { label: "Imprint", href: "/impressum" },
            { label: "Privacy policy", href: "/datenschutz" },
            { label: "Terms of use", href: "/nutzungsbedingungen" },
            { label: "Terms & conditions", href: "/agb" },
          ],
        },
      ],
      download: "Get the app",
      rights: "All rights reserved.",
      credit: "Designed by",
    },
    legal: {
      back: "Back to home",
      eyebrow: "Legal",
      langNote: "This page is available in German only, as it is legally binding in its original wording.",
      updated: "Last updated",
    },
    contact: {
      eyebrow: "Contact",
      title: "Talk to us.",
      subtitle:
        "Questions about the app, the PRO subscription or the VDB version? Press or partner enquiry? Write to us – we usually reply within two working days.",
      directTitle: "Reach us directly",
      form: {
        name: "Name",
        namePh: "First and last name",
        email: "Email",
        emailPh: "you@example.com",
        topic: "Topic",
        topics: [
          { value: "allgemein", label: "General question" },
          { value: "support", label: "Support / technical issue" },
          { value: "pro", label: "PRO subscription & billing" },
          { value: "vdb", label: "VDB version" },
          { value: "revier", label: "Territory management & import" },
          { value: "presse", label: "Press & partners" },
        ],
        message: "Message",
        messagePh: "What is it about?",
        consent: "I have read the",
        consentLink: "privacy policy",
        consentTail: "and agree to the processing of my details for handling this enquiry.",
        submit: "Send message",
        sending: "Sending …",
        successTitle: "Thanks, your message has arrived.",
        successBody: "We will get back to you as soon as possible.",
        again: "Write another message",
        errorTitle: "That did not work, unfortunately.",
        errorBody: "Please try again in a moment or email us directly.",
        required: "Required",
        invalidEmail: "Please enter a valid email address.",
        tooShort: "Please add a little more detail (at least 10 characters).",
        consentRequired: "Please agree to the processing.",
      },
    },
    appstore: {
      ios: { top: "Download on the", bottom: "App Store" },
      android: { top: "Get it on", bottom: "Google Play" },
    },
    consent: {
      title: "Cookies & external services",
      body:
        "We only use strictly necessary storage (your language setting and your choice here). External content such as YouTube videos is loaded only after you agree – data is then transferred to Google.",
      acceptAll: "Accept all",
      rejectAll: "Necessary only",
      settings: "Settings",
      save: "Save selection",
      back: "Back",
      manage: "Cookie settings",
      privacy: "Privacy policy",
      imprint: "Imprint",
      alwaysOn: "Always on",
      categories: [
        {
          id: "necessary",
          name: "Necessary",
          desc: "Stores your language choice and this consent in your browser (localStorage). Nothing is shared with third parties.",
          required: true,
        },
        {
          id: "media",
          name: "External media",
          desc: "YouTube videos (Google Ireland Ltd.). Loading them transfers your IP address and device information to Google; YouTube may set cookies.",
          required: false,
        },
      ],
      blocked: {
        title: "YouTube video blocked",
        body: "You have not allowed external media. Loading it transfers data to Google.",
        once: "Load this video only",
        allow: "Always allow external media",
      },
    },
    placeholder: {
      label: "Placeholder",
      note: "Screenshot coming soon",
    },
  },
};
